import { render, staticRenderFns } from "./SettingsSetup.vue?vue&type=template&id=6b51cc4c&scoped=true&"
import script from "./SettingsSetup.vue?vue&type=script&lang=js&"
export * from "./SettingsSetup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSetup.vue?vue&type=style&index=0&id=6b51cc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b51cc4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b51cc4c')) {
      api.createRecord('6b51cc4c', component.options)
    } else {
      api.reload('6b51cc4c', component.options)
    }
    module.hot.accept("./SettingsSetup.vue?vue&type=template&id=6b51cc4c&scoped=true&", function () {
      api.rerender('6b51cc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/SettingsSetup.vue"
export default component.exports